import { ApiBase } from "./api-base";

export class HttpStatisticApi extends ApiBase {
  onApiName(): string {
    return "Statistic";
  }

  onUrlPath(): string {
    return "/statistic";
  }

  public async post(param: any) {
    const response = await this.requestPost(param);
    return response;
  }
}
